<section id="simple">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title">Examenes alumno</h5>
        </div>
        <table class="table table-striped tablaexamenes">
          <thead>
            <tr>
              <th>Asignatura</th>
              <th>Examen</th>
              <th>Tipo</th>
              <th>Nota</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let examen of examenes">
              <td>{{examen.asignatura}}</td>
              <td>{{examen.examen}}</td>
              <td>{{examen.tipo}}</td>
              <td>{{examen.nota}}</td>
              <td>{{ examen.fecha.date | date: "dd-MM-yy"}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>